import React from "react";

export default function Footer() {
  return (
    <footer className="bg-[#0A1F44] text-slate-300 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-x-0 top-0 h-[2px] cmyk-gradient" />
      <div className="absolute inset-0 bg-grid-dark opacity-30 pointer-events-none" />

      <div className="relative w-full px-5 lg:px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-sm text-slate-400 text-center md:text-left">
          © {new Date().getFullYear()} Ecoption Supply · Consumíveis Económicos &amp; Fornecimento
        </div>
        <div className="text-xs text-slate-500 uppercase tracking-[0.22em] font-semibold">
          Made in Portugal
        </div>
      </div>
    </footer>
  );
}
